// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper__3-QoH","header":"header__13uCf","submission-comment-item":"submission-comment-item__2p1AP","white":"white__35oIm","blue":"blue__2iJWT","footer":"footer__3q2G7"};